import UserInput from 'v3/common/components/UserInput';
import { FC, FormEvent } from 'react';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';
import Button from 'v3/common/components/Button';

const HdfcSky: FC<BrokerSpecificComponentsProps> = ({ userConfigs, brokerSpecificHandles, switchPage }) => {
  const { reDirectPage, validateClientIdAndRedirect, updatePartialConfigs, changeApiKey, isMobile } =
    brokerSpecificHandles;
  const {
    clientId,
    isClientValidated,
    shouldShowApiKey,
    shouldShowSecretKey,
    apiKey,
    secretKey,
    isLoading,
    isValidForm,
    selectedBrokerConfig,
  } = userConfigs;

  const broker = selectedBrokerConfig?.id;

  return (
    <form
      id={`broker-${broker}`}
      onSubmit={(e: FormEvent) => {
        e.preventDefault();
        return isClientValidated ? reDirectPage() : validateClientIdAndRedirect();
      }}
    >
      <UserInput
        labelValue="Client Id"
        id={`${selectedBrokerConfig?.id}-client-id`}
        value={clientId}
        isDisabled={isClientValidated}
        placeholder="Enter Client Id"
        onHandleChange={(value) => updatePartialConfigs({ clientId: value })}
        autoFocus={!isMobile}
      />

      {clientId && !isClientValidated && (
        <button type="button" onClick={() => changeApiKey()}>
          <i className="fa-regular fa-gear fa-spin" />
          Change api?
        </button>
      )}

      {shouldShowApiKey && (
        <UserInput
          labelValue="API Key"
          id={`${broker}-api-key`}
          value={apiKey}
          placeholder="Enter API Key"
          onHandleChange={(value) => updatePartialConfigs({ apiKey: value })}
        />
      )}
      {shouldShowSecretKey && (
        <UserInput
          labelValue="API Secret"
          id={`${broker}-secret-key`}
          value={secretKey}
          type="password"
          placeholder="Enter API Secret"
          onHandleChange={(value) => updatePartialConfigs({ secretKey: value })}
        />
      )}

      {isClientValidated && (
        <button type="button" onClick={() => switchPage()}>
          <img src="/gear.svg" alt="" />
          <span className="ms-2">How to generate API?</span>
        </button>
      )}

      {!isValidForm && <div className="alert alert-danger">Please provide the details</div>}

      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button type="submit" isLoading={isLoading} form={`broker-${broker}`}>
          {isClientValidated ? 'Login' : 'Validate'}
        </Button>
      </PortalToTarget>
    </form>
  );
};

export default HdfcSky;
